import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {getToken, setRefreshToken, setToken} from '@/utils/auth'

NProgress.configure({ showSpinner: false })// NProgress Configuration

const whiteList = ['/', '/register', '/login', '/auth-redirect', '/404', '/401', '/lock', '/reset-password']// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.path === '/register') {
    next('/login')
    NProgress.done() // 结束进度条
    return // 终止后续逻辑
  }
  const sysConfig = store.getters.sysConfig
  if (sysConfig && sysConfig.sys_web_name && sysConfig.sys_web_name !== document.title) {
    document.title = sysConfig.sys_web_name
  }
  const token = to.query.token
  if (token) {
    setToken(token);
    setRefreshToken(token);
    store.commit('SET_TOKEN', token);
    store.commit('SET_REFRESH_TOKEN', token)
    next()
  }
  if (getToken()) { // 判断是否已登录
    if (to.path === '/login' || to.path === '/register') {
      next({ path: '/' })
    } else {
      const userInfo = store.getters.userInfo
      if (Object.keys(userInfo).length === 0) { // 判断当前用户是否已拉取完 user_info 信息
        store.dispatch('GetUserInfo').then(res => { // 拉取 user_info
          next({ ...to, replace: true }) // hack 方法 确保 addRoutes 已完成
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        next()
      }
    }
    NProgress.done()
  } else {
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/login') // 重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js